import { useRef } from 'react';

/**
 * Run a function synchronously only once
 */
export function useOnceSync<T extends (...params: Parameters<T>) => any>(
  fn: T,
  ...params: Parameters<T>
): void {
  // Effects do not run in order of render (parent > child), there is no guarantee of
  // synchronously running the code. So we can not use it for this edge case.
  const isRun = useRef(false);

  if (!isRun.current) {
    isRun.current = true;
    return fn(...params);
  }
}
